// extracted by mini-css-extract-plugin
export var typingIndicator = "_qv-0";